import { render } from "./ReportGoals.vue?vue&type=template&id=63f0693a"
import script from "./ReportGoals.vue?vue&type=script&lang=js"
export * from "./ReportGoals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/ReportGoals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63f0693a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63f0693a', __exports__)) {
    api.reload('63f0693a', __exports__)
  }
  
  module.hot.accept("./ReportGoals.vue?vue&type=template&id=63f0693a", () => {
    api.rerender('63f0693a', render)
  })

}


export default __exports__